import { EndorsementCard } from './components/EndorsementCard';
import { useEndorsementQuotes } from './hooks/useEndorsementQuotes';

export const EndorsementQuotes: React.FC = () => {
	const {
		data: { endorsements },
	} = useEndorsementQuotes();

	if (endorsements.length === 0) return null;
	return (
		<>
			{/* Mobile */}
			<div
				data-testid="endorsements-section"
				className="snap-x snap-mandatory overflow-x-scroll md:hidden [&::-webkit-scrollbar]:hidden"
				// oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- not fixed to avoid regression risk from an automated markup rewrite; needs manual accessibility review
				role="region"
				// FIXME: hardcoded aria-label, should use an i18n key
				aria-label="Quotes from endorsers"
			>
				{/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
				<ul role="list" className="flex gap-5">
					{endorsements.map((endorsement) => (
						<li
							key={`${endorsement.author.displayName}_${endorsement.message}`}
							aria-roledescription="slide"
							className="snap-start"
						>
							<EndorsementCard endorsement={endorsement} />
						</li>
					))}
				</ul>
			</div>

			{/* Desktop */}
			<div className="hidden md:block">
				{/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
				<ul role="list" className="columns-2 lg:columns-3">
					{endorsements.map((endorsement) => (
						<li key={`${endorsement.author.displayName}_${endorsement.message}`} className="mb-4 break-inside-avoid">
							<EndorsementCard endorsement={endorsement} />
						</li>
					))}
				</ul>
			</div>
		</>
	);
};
